import React from 'react';
import { motion } from 'framer-motion';
import { HelpCircle, ArrowRight } from 'lucide-react';
export function DecisionGuide() {
  const guides = [{
    if: 'Si quieres crear un ebook completo',
    then: 'Empieza con Ebook Writer'
  }, {
    if: 'Si necesitas copy persuasivo que conecte',
    then: 'Usa Identity Persuasion Copywriter'
  }, {
    if: 'Si quieres crear sales letters que conviertan',
    then: 'Elige Sales Letter Weapon'
  }, {
    if: 'Si necesitas optimizar tus Meta Ads',
    then: 'Usa Meta Ads Decision Engine'
  }, {
    if: 'Si quieres crear PDFs que se vuelvan virales',
    then: 'Elige The Viral PDF Lab'
  }, {
    if: 'Si buscas un sistema completo para tu marca',
    then: 'Usa AI Complete Brand Operation System'
  }];
  return <section className="py-12 md:py-16 bg-slate-50 border-y border-slate-200" data-id="element-254">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-255">
        <div className="text-center mb-8 md:mb-10" data-id="element-256">
          <div className="inline-flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-full bg-orange-100 text-orange-600 mb-3 md:mb-4" data-id="element-257">
            <HelpCircle className="w-5 h-5 md:w-6 md:h-6" data-id="element-258" />
          </div>
          <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-slate-900 px-2" data-id="element-259">
            ¿No sabes cuál Lloyd elegir primero?
          </h2>
        </div>
        <div className="grid gap-3 md:gap-4" data-id="element-260">
          {guides.map((guide, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-3 md:p-4 lg:p-6 rounded-lg md:rounded-xl border border-slate-200 flex flex-col md:flex-row md:items-center justify-between shadow-sm gap-2 md:gap-0" data-id="element-261">
              <div className="font-medium text-slate-700 text-sm md:text-base" data-id="element-262">
                {guide.if}
              </div>
              <div className="hidden md:block text-slate-300 mx-4" data-id="element-263">
                <ArrowRight className="w-5 h-5" data-id="element-264" />
              </div>
              <div className="font-bold text-teal-700 bg-teal-50 px-3 md:px-4 py-1.5 md:py-2 rounded-lg text-sm md:text-base" data-id="element-265">
                {guide.then}
              </div>
            </motion.div>)}
        </div>
        <p className="text-center text-slate-500 mt-6 md:mt-8 text-xs md:text-sm px-2" data-id="element-266">
          Si tienes dudas, elige la opción más básica. Lo importante es empezar
          con uno.
        </p>
      </div>
    </section>;
}